import React from "react";
import { useBnbSelector } from "../../../redux/store";
import * as Badge from "../../../../../../common-deprecated/styles/toyota/Badge";
import * as Tag from "../../../../../../common-deprecated/styles/toyota/Tag";
import type { EcoTagType } from "../../../../../../common-deprecated/types/CommonTypes";
import useEcoTag from "../../../hooks/shared/useEcoTag";
import { getEcoBadgeUrl } from "../../../../../../common-deprecated/utils";

type PropsType = {
    type: EcoTagType;
};

const HorizontalEcoTag = ({ type }: PropsType): JSX.Element | null => {
    const settings = useBnbSelector((state) => state.commonSettings);
    const { label, ecoBadge, available } = useEcoTag(type);
    const ecoBadgeUrl = getEcoBadgeUrl(ecoBadge, settings);

    if (!label) return null;
    return (
        <Tag.EcoHorizontal>
            {ecoBadgeUrl && <Badge.EcoBadge imageUrl={ecoBadgeUrl} />}
            {available.position === "left" && available.label}
            <Tag.Motorisation type={type}>{label}</Tag.Motorisation>
            {available.position === "right" && available.label}
        </Tag.EcoHorizontal>
    );
};

export default HorizontalEcoTag;
